export const MediaQuery = {
  MAX_350: "(max-width: 350px)",
  MAX_479: "(max-width: 479px)",
  MIN_480: "(min-width: 480px)",
  MAX_767: "(max-width: 767px)",
  MIN_768: "(min-width: 768px)",
  MAX_1023: "(max-width: 1023px)",
  MIN_1024: "(min-width: 1024px)",
  MAX_1280: "(max-width: 1280px)",
  MIN_1280: "(min-width: 1280px)",
  MIN_1440: "(min-width: 1440px)",
  MIN_1920: "(min-width: 1920px)",
};

export const MediaQueryHeight = {
  MAX_350: "(max-height: 350px)",
  MAX_479: "(max-height: 479px)",
  MIN_480: "(min-height: 480px)",
  MAX_767: "(max-height: 767px)",
  MIN_768: "(min-height: 768px)",
  MAX_1023: "(max-height: 1023px)",
  MIN_1024: "(min-height: 1024px)",
  MAX_1280: "(max-height: 1280px)",
  MIN_1280: "(min-height: 1280px)",
  MIN_1440: "(min-height: 1440px)",
  MIN_1920: "(min-height: 1920px)",
};

export const Orientation = {
  landscape: "landscape",
  portrait: "portrait",
};
